module.exports = __webpack_public_path__ + "static/Scheme-PureKit@2x-3d3cdf952e4a9061a935bc1b89ab2867.png";